<template>
    <f-dialog
        v-model       = "show"
        :width        = "500"
        :show-header  = "true"
        :hide-actions = "false"
        :inset        = "true"
        content-class = "dialog-border"
        :title        = "$t('disposition.order.title')"
        @store        = "onStore"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <v-form ref="form">
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <v-text-field
                            :label  = "$t('disposition.order.no')"
                            v-model = "order.no"
                            :rules  = "[ required ]"
                        />
                    </v-col>

                    <v-col class="no-frame pl-2">
                        <f-enum-select
                            v-model    = "order.status"
                            :label     = "$t('disposition.order.status')"
                            module     = "disposition"
                            type       = "dispositionOrderStatus"
                            :rules  = "[ required ]"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame col-9">
                        <f-enum-autocomplete
                            v-model  = "order.customer"
                            :label   = "$t('disposition.order.customer')"
                            module   = "msd"
                            type     = "customer"
                            :rules  = "[ required ]"
                        />
                    </v-col>
                    {{ color.hex }}
                    <v-col class="no-frame col-3" style="text-align: right">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    elevation="0"
                                    class="dialog-button mt-4 lm-border"
                                    style="min-width: 100px!important;"
                                    :color = "color"
                                    v-on="on"
                                >
                                    {{ $t('disposition.order.color') }}
                                </v-btn>
                            </template>
                            <v-color-picker
                                mode = "hexa"
                                value="color"
                                v-model="color"
                                hide-inputs
                                hide-sliders
                                hide-canvas
                                show-swatches
                                class="mx-auto"
                            ></v-color-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <v-textarea
                            v-model        = "order.comment"
                            :label         = "$t('disposition.order.comment')"
                            :rows          = "4"
                            class          = "mt-3"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            no-resize
                            counter
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame mt-4">
                    <v-col class="no-frame">
                        <f-title
                            :title = "$t('disposition.order.scope.title')"
                        />
                    </v-col>
                </v-row>

                <p-order-scope
                    v-model="order.scope"
                />
            </v-form>
        </template>
    </f-dialog>
</template>

<script>

import Core                from "@/modules/core/service/Core";
import Disposition         from "@/modules/dis/service/Disposition";
import FEnumAutocomplete   from "@/modules/core/components/utils/FEnumAutocomplete.vue";
import FDialog             from "@/modules/core/components/utils/FDialog.vue";
import FTitle              from "@/modules/core/components/utils/FTitle.vue";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect.vue";
import POrderScope from "@/modules/dis/components/order/overview/private/POrderScope.vue";

export default {
    name: "POrderEditor",

    components: {
        POrderScope,
        FEnumSelect,
        FTitle,
        FDialog,
        FEnumAutocomplete,
    },

    props: {
        value: {

        },

        order: {

        }
    },

    data: () => ({
        show: false,
        color: "#ffffff"
    }),

    mounted() {
        this.show = this.value;
        this.setColor()
    },

    watch: {
        value () {
            this.show = this.value;
            this.setColor()
        },

        order () {
            this.setColor()
        }
    },

    methods: {
        onStore () {
            if (!this.$refs.form.validate ()) {
                return;
            }

            this.order.color = this.color;
            Disposition.order.store(this.order).then(order => {
                this.$emit("stored", order)
                this.$emit("input", false);
            })
        },

        onCancel () {
            this.$emit("input", false);
        },

        required (value) {
            return Core.rule.required(value);
        },

        setColor () {
            this.$nextTick().then(() => {
                this.color = this.order && this.order.color ? this.order.color : "#ffffff";
            })
        }
    }
}
</script>

<style scoped>

</style>